<template>
  <div>
    <form @submit.prevent="submit()">

      <div class="mb-3">
        <SGPFormSelectComponent 
            :name="'acl_modulo_id'"
            :listaDeOptions="listaDeModulos"
            v-model="formulario.acl_modulo_id"
            :optionLabel="'modulo'"
            :placeholder="'Módulo'"
            :error="validationErrors.first('acl_modulo_id')"
            data-vv-as="Módulo"
            v-validate="'required'"
          />
      </div>
      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'submodulo'"
            v-model="formulario.submodulo" 
            :placeholder="'Nome'"
            data-vv-as="Nome"
            v-validate="'required|max:255'"
            :error="validationErrors.first('submodulo')"
         />
      </div>      
      <div class="container-botoes">
        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>
        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">Cancelar</button>
     </div>
      
    </form>
    

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "FormularioSubModuloComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    submodulo: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      formulario: this.$props.submodulo || {
        submodulo: '',
        acl_modulo_id: ''
      }
    }
  },
  computed: {
    ...mapGetters('submodulos', ['listaDeSubModulos']),
    ...mapGetters('modulos', ['listaDeModulos'])
  },
  methods: {
    ...mapActions('submodulos', [
      'salvarSubModulo',
      'recuperarSubModulo',
      'atualizarSubModulo',
      'listarSubModulos'
    ]),
    ...mapActions('modulos', [
      'listarModulos'
    ]),
     validate: function () {
          this.$validator.validateAll();
        },
     limparCampos () {
       this.formulario.submodulo = '';
        this.formulario.acl_modulo_id = '';
        this.$validator.reset();
     },   
    submit () {
      // invoca o vee validade para a validação dos campos
       this.$validator.validateAll().then(async (result) => {
        if (result) {
          // eslint-disable-next-line
          if(this.tipoFormulario === 'salvar') {
            const resp = await this.salvarSubModulo(this.formulario);            
            if(!resp) { 
              return;
            }
          }else{
              const resp = await this.atualizarSubModulo(this.formulario);
              if(!resp){
                return;
              } 
          }

          this.limparCampos();
          this.fecharModal();
          return;
        }
      });     
       
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  },beforeMount(){
    this.listarModulos();
 }

}
</script>